import BaseOption from "%/dynamic-component-editor/classes/base-option";
import FeedFilterChip from "%/dynamic-component-editor/classes/feed-filter-chip";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class FilterChipTextFormat extends BaseOption {
  static label = "Filter Chip Text";
  static userInterfaceComponent = {
    component: inspectorTools.RADIO_BAR,
    descriptionMessage: "Show each hashtag as written, or as words: pain_and_rehab reads Pain and Rehab.",
    props: {
      options: [
        { value: FeedFilterChip.TEXT_FORMAT_AS_WRITTEN, label: "As Written" },
        { value: FeedFilterChip.TEXT_FORMAT_READABLE, label: "Readable" },
      ],
    },
  };

  static defaultValue = FeedFilterChip.TEXT_FORMAT_DEFAULT;
}
